export interface cv_ShipmentAnimalCondition {
    C_ShipmentAnimalCondition_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    ShipmentAnimalCondition: string;
    SortOrder: number | null;
    Version: number;
}
